var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://convidadoguru.com/gurunews-home"}},[(_vm.mobile)?_c('img',{attrs:{"id":"banner-gurubets","src":"img/guru/LP_GURUNEWS_MOB.jpg"}}):_c('img',{attrs:{"id":"banner-gurubets","src":"img/guru/LP_GURUNEWS_DESK.jpg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }